/* 个性化学习目标页面 */
<template>
<div class="container">
  <div class="container_body">
  <!--header-->
  <div id="header">
    <div class="header-title" v-bind:style="{fontSize: changeFontSize() + 'px'}"><span>{{ lang.plan_title | multiReplace([['{u_name}', u_name], ['{unit}', unit]]) }}</span></div>
    <div class="bg"><img src="../../../../static/images/PeasonalizedTarget-background.png"></div>
  </div>

  <!--介绍-->
  <div id="desc">
    <div class="resource intro" v-if="validPart(video_content) || validPart(audio_content) || validPart(book_content)">
      <p v-html="getProcessedHtml(lang['intro'], [[`{u_name}`, u_name]])"></p>
      <div v-html="target_desc"></div>
    </div>
    <div v-else>
      <p v-html="getProcessedHtml(lang['intro'], [[`{u_name}`, u_name]])"></p>
    </div>
  </div>

  <div id="resource">
    <!--动画片  wanfeng @20200811 hide the iqiyi video-->
    <!-- <div class="resource resource_cartoon" v-if="video_content.length>0"> -->
    <div class="resource resource_cartoon" v-if="validPart(video_content)">
      <p>
        <span class="resource-title">
          <span class="fa fa-star"></span>
          <strong>{{ lang.resource_cartoon }}:</strong>
        </span>
      </p>
      <div class="resource-content">
        <ul>
          <li v-for="video in video_content" v-if='showVideo(video.video_link)'>
            <a @click="content_href_learning('video',video.id_decode)" :href="'/resource/video/' + video.id + tailUrl">{{video.title_cn}}</a>
          </li>
        </ul>
      </div>
    </div>

    <!--精选的儿歌  wanfeng @20200811 hide the iqiyi video-->
    <div class="resource resource_song" v-if="validPart(audio_content)">
      <p>
        <span class="resource-title">
          <span class="fa fa-star"></span>
          <strong>{{ lang.resource_song_1 }}:</strong>
        </span>
      </p>
      <div class="resource-content">
        <ul>
          <li v-for="audio in audio_content" v-if='showVideo(audio.video_link)'>
            <a @click="content_href_learning('audio',audio.id_decode)" :href="'/resource/audio/' + audio.id + tailUrl">{{audio.title_cn}}({{audio.title}})</a>
          </li>
        </ul>
      </div>
    </div>

    <!--配套的绘本 wanfeng @20200811 hide the iqiyi video-->
    <div class="resource resource_book" v-if="validPart(book_content)">
      <p><span class="resource-title">
          <span class="fa fa-star"></span>
          <strong>{{ lang.resource_book_1 }}:</strong></span>
      </p>
      <div class="resource-content">
        <ul>
          <li v-for="book in book_content" v-if='showVideo(book.video_link)'>
            <a @click="content_href_learning('book',book.id_decode)" :href="'/resource/book/' + book.id + tailUrl">{{book.title_cn}}({{book.title}})</a>
          </li>
        </ul>
      </div>
    </div>

    <!--亲子活动-->
    <div class="resource resource_activity" v-if="activity_content.length>0">
      <p>
        <span class="resource-title">
          <span class="fa fa-star"></span>
          <strong>{{ lang.resource_activity }}:</strong>
        </span>
      </p>
      <div class="resource-content">
        <ul>
          <li v-for="activity in activity_content">
            <a @click="content_href_learning('activity',activity.id_decode)" :href="'/resource/activity?id=' + activity.id + newtailUrl">{{activity.activity}}({{activity.activity_en}})</a>
          </li>
        </ul>
      </div>
    </div>
  </div>
  </div>
</div>
</template>

<script>
require('@/assets/css/peasonalized-target.css')
import 'font-awesome/css/font-awesome.css'
import BaseVue from '@/components/BaseVue'

export default {
  name: 'PeasonalizedTarget',
  extends: BaseVue,
  /* inherit from BaseVue,the para in data can call on above */
  data() {
    return {
      unit: 0,
      u_name: 'Jack',
      target_desc: '',
      book_content: [],
      video_content: [],
      audio_content: [],
      activity_content: [],
      url_params: ''
    }
  },
  computed: {
    tailUrl: function() {
      return this.url_params === '' ? '' : '?' + this.url_params
    },
    newtailUrl: function() {
      return this.url_params === '' ? '' : '&' + this.url_params
    },
  },
  created: async function() {
    // let u_name = this.$route.params.u_name
    let level = this.$route.query.level
    let unit = this.$route.query.unit
    let u_name = this.$route.query.name
    let uid = this.$route.query.uid
    let sig = this.$route.query.sig
    // console.log(this.$route);
    if (level === undefined || unit === undefined || u_name === undefined || sig === undefined) return
    let realSig = this.generateSig(uid + level + unit)
    // console.log('sig: ' + realSig + '; sig === realSig: ' + (realSig === sig));
    // console.log('checkSig: ' + this.checkSig(uid + level + unit, sig));
    if (!this.checkSig(uid + level + unit, sig)) return
    this.url_params = this.$route.fullPath.split('?')[1]
    this.unit = unit
    this.u_name = u_name
    //apihost add the sig
    // let url = this.APIHOST + 'cej_target_new?' + $.param({level: level, unit:unit, uid: uid, sig:sig})
    let url = this.GATEWAY_ORIGINAL + 'bigdata/cej_target/query_unit_detail?' + $.param({level: level, unit:unit, uid: uid, sig:sig})
    let that = this
    // 增加个性化学习页面埋点
    pindData.add_params({"t":"upp.000001"});
    let value = '{"t":"upp.000001","v":{"action":"PG_UNIT_PERSONALIZED_PLAN","userid":'+ uid + ',"unit_index":' + unit + ',"level_index":' + level +'}}';
    __sdonclick(value);
    await this.getLang()
    document.title = this.lang.PeasonalizedTargetTitle
    this.target_desc = this.lang.target_desc
    /* queryData from basevue */
    this.queryData(url, function(data) {
      that.target_desc = data.target_desc
      that.book_content = data.book_content
      that.video_content = data.video_content
      that.audio_content = data.audio_content
      that.activity_content = data.activity_content
    })
  },
  methods: {
    getProcessedHtml(value, params) {
      let processedString = this.$options.filters.multiReplace(value, params);
      return processedString;
    },
    changeFontSize: function(){
      if (window.innerWidth >500) return 20
      return  parseInt(375 / (18+this.u_name.length + this.unit.toString().length))
    },
    showVideo: function(url){
      //判断是否需要展示视频，是爱奇艺的为'0'标识
      if(url == '1') return true
      return false
    },
    validPart: function(el){
      //判断此内容板块是否返都是爱奇艺的视频
      let ind = 0
      for (let i = 0; i < el.length; i++) {
        if(el[i]['video_link'] == '1') ind++
      }
      if(ind > 0) return true
      return false
    },
    content_href_learning: function(type,id){
      //点击单元个性化计划中的超链子页面学习（video、audio、book、activity）
      let action = "CK_UNIT_PERSONALIZED_PLAN_"+ type.toLocaleUpperCase( )
      pindData.pind_send( {"action": action,"type": type,"id": id} );
    },
  }
}
</script>



// WEBPACK FOOTER //
// src/components/template/target/PeasonalizedTarget.vue